import { Alert, Stack, Typography, CircularProgress, Chip, LinearProgress } from '@mui/material'

// Define types for timepoint submission data
interface ContainerSubmission {
  container_submission_id: string
  dicom_json?: Record<string, unknown> | null
}

interface TimePointSubmissionData {
  data?: {
    timepoint_submission: {
      container_submissions: ContainerSubmission[]
    }
  }
}

interface StatusAlertProps {
  phiWorkflowInProgress: boolean
  phiWorkflowStatus: string
  isPhiStatusLoading: boolean
  timePointSubmissionData: TimePointSubmissionData | undefined
  getStatusMessage: (status: string) => string
}

export function StatusAlert({
  phiWorkflowInProgress,
  phiWorkflowStatus,
  isPhiStatusLoading,
  timePointSubmissionData,
  getStatusMessage,
}: StatusAlertProps) {
  // Show status alert only when no DICOM data yet or during initial loading
  const shouldShowAlert =
    (phiWorkflowInProgress &&
      !timePointSubmissionData?.data?.timepoint_submission.container_submissions.some(
        (submission) => submission.dicom_json && Object.keys(submission.dicom_json).length > 0,
      )) ||
    isPhiStatusLoading

  if (!shouldShowAlert) {
    return null
  }

  return (
    <Alert
      severity="info"
      icon={<CircularProgress size={20} color="info" />}
      sx={{ mb: 2 }}
      action={
        <Chip
          label={phiWorkflowStatus === 'converting' ? 'Converting Files' : 'Processing'}
          color="primary"
          size="small"
          variant="outlined"
        />
      }
    >
      <Stack spacing={1} width="100%">
        <Typography variant="body2">{getStatusMessage(phiWorkflowStatus)}</Typography>
        <LinearProgress variant="indeterminate" color="primary" sx={{ height: 4, borderRadius: 2 }} />
      </Stack>
    </Alert>
  )
}
